import { FormSelectSearchable } from "@/components/forms";
import { useForeignKeyData } from "@/hooks/use-foreign-key-data";
import { capitalize } from "@/lib/utils";
import { ControllerProps } from "react-hook-form";
import { ReactNode, useMemo } from "react";

export function FormComboboxForeignKey({
  referenceTable,
  nestedColumnName,
  name,
  label,
  control,
  className,
  buttonClassName,
  required,
}: {
  name: string;
  label?: ReactNode;
  control: ControllerProps<any, any>["control"];
  referenceTable: string;
  nestedColumnName: string | string[];
  className?: string;
  buttonClassName?: string;
  required?: boolean;
}) {
  const { optionsData, isLoading } = useForeignKeyData(
    referenceTable,
    nestedColumnName
  );

  const memoizedOptions = useMemo(() => {
    return optionsData || [];
  }, [optionsData]);

  return (
    <FormSelectSearchable
      name={name}
      label={typeof label === "string" ? label : capitalize(name)}
      options={memoizedOptions}
      control={control}
      triggerClassName={buttonClassName || className}
      contentClassName="aero:z-[100]" // Higher z-index to appear above Sheet (z-50)
      wrapperClassName="aero:relative" // Ensure proper stacking context
      required={required}
      disabled={isLoading}
      placeholder={isLoading ? "Loading..." : "Select option..."}
      searchPlaceholder="Search..."
    />
  );
}
